// FAZ-53 — Detay sayfasındaki "Halk Masası Notu" kartı.
//
// Kullanıcının istediği sıra: ÖNCE başvuruyu kimin oluşturduğu, SONRA not.
// Not boşsa kart yine çizilir ve not yerinde silik "Not eklenmemiş" durur.
//
// Görünürlük (§3.4):
//                | not VAR                   | not YOK
//   izin VAR     | Oluşturan + Tarih + Not   | Oluşturan + Tarih + "Not eklenmemiş"
//   izin YOK     | Tarih + Not               | kart GİZLENİR
//
// İzin kararı backend'de verilir: izinsiz kullanıcıya `created_by` HİÇ gelmez.
// Bu bileşen ayrıca izin sorgulamaz — verinin varlığı tek doğruluk kaynağıdır.

import React from "react";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";

import HeadsetIcon from "../icons/HeadsetIcon";
import TrDateTime from "../utils/TrDateTime";
import { ensureFirstUpperTr } from "../utils/textFormat";

export default function HalkMasasiNoteCard({
  assistedIntake,
  collapsed = false,
  onToggle,
}) {
  if (!assistedIntake) return null;

  const createdBy = assistedIntake.created_by || null;
  const note = (assistedIntake.note || "").trim();

  // Ne oluşturan ne not gösterilebiliyorsa geriye yalnız tarih kalır —
  // tek başına anlamsız bir kart çizmeyiz (bugünkü davranışın korunması).
  if (!createdBy && !note) return null;

  return (
    <div
      className={`details-card details-card--kv ${
        collapsed ? "details-card--collapsed" : ""
      }`}
    >
      <div
        className="card-header card-header--clickable"
        onClick={onToggle}
      >
        <div className="card-header-left">
          {/* Listedeki kanal ikonuyla AYNI görsel dil — kullanıcı kartta da
              çağrı merkezi kulaklığını görmek istedi. */}
          <HeadsetIcon className="card-header-icon" />
          <span>Halk Masası Notu</span>
        </div>
        <ChevronUpDownIcon
          className={
            collapsed
              ? "card-header-toggle-icon collapsed"
              : "card-header-toggle-icon"
          }
        />
      </div>

      {!collapsed && (
        <div className="card-body">
          {/* 1) ÖNCE: başvuruyu kim oluşturdu (yalnız izinliye gelir) */}
          {createdBy && (
            <>
              <p>
                <strong>Oluşturan:</strong>{" "}
                <span className="details-value">
                  {createdBy.full_name || "—"}
                  {createdBy.role_name ? ` (${createdBy.role_name})` : ""}
                </span>
              </p>
              {createdBy.unit_name && (
                <p>
                  <strong>Birim:</strong>{" "}
                  <span className="details-value">{createdBy.unit_name}</span>
                </p>
              )}
            </>
          )}

          {/* 2) Tarih */}
          {assistedIntake.created_at && (
            <p>
              <strong>Tarih:</strong>{" "}
              <TrDateTime value={assistedIntake.created_at} />
            </p>
          )}

          {/* 3) SONRA: not — yoksa silik uyarı */}
          <p>
            <strong>Not:</strong>{" "}
            {note ? (
              <span className="details-value">{ensureFirstUpperTr(note)}</span>
            ) : (
              <span className="details-value details-value--muted">
                Not eklenmemiş
              </span>
            )}
          </p>
        </div>
      )}
    </div>
  );
}
